import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import renderViewsState from '../shared/render-views-state';
import { bindActionCreators } from 'redux';
import Calendar from '../shared/calendar/main';
import CurrentResend  from './components/resendProgress';

import SwitchOffers from '../../modules/shared/switch';

import {Field, reduxForm} from 'redux-form';
import SelectField from '../shared/form-elements/multiselect/select';

lessRequire('modules/global-postback/resend.less');

const ResendMainForm = renderViewsState(props => {
	const { intl } = props;
	const switchControlConfig = [{
		className: '',
		title: intl('Настройки'),
		url: 'campaigns/global-postback/'
	}, {
		className: '',
		title: intl('Глобальный постбэк лог'),
		url: 'campaigns/global-postback/log/'
	}, {
		className: '',
		title: intl('Переотправка постбека'),
		url: 'campaigns/global-postback/resend/'
	}];

	return (
		<div className="global-postback container">
			<div className="content-container">
				<div className="content-container__title">
					<h2 className="font-proxima-nova-bold">{intl('Глобальный постбэк')}</h2>
					<div className="global-postback__switch">
						<SwitchOffers links={switchControlConfig}  intl={intl}/>
					</div>
				</div>
				<div className="global-postback-content">
					<div className="resend__container">
						<PostbackResendFilter {...props}/>
						<Calendar
							{...props.calendar}
							onInit={props.calendarResendPostbackInit}
							onToggle={props.calendarResendPostbackToggle}
							onChange={e => {
								props.calendarResendPostbackChange(e);
								props.getResendPostbackUrls();
							}}
							onApply={props.calendarResendPostbackApply}
						/>
						<CurrentResend
							resendPostbacksLeft={props.resendPostbacksLeft}
							resendPostbacksTotal={props.resendPostbacksTotal}
							intl={props.intl}
							getResendPostbackUrls={props.getResendPostbackUrls}
						/>
						<button
							className="button yellow-btn resend__button"
							onClick={props.resendNewPostbackUrls}
						>
							{intl('Переотправить по обновленным постбек урлам')}
						</button>
						<button
							className="button yellow-btn resend__button resend-new__button"
							onClick={props.resendOldPostbackUrls}
						>
							{intl('Переотправить постбеки')}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
});

const Form = ({ intl, resendLookups, fetchResendPostbackLookup, getResendPostbackUrls }) => (
	<form
		action="#"
		className="resend-filter"
		onClick={() => fetchResendPostbackLookup()}
	>
		<div className="resend-filter__item">
			<Field
				name="campaignes"
				placeholder={intl('Потоки')}
				component={SelectField}
				searchable={true}
				multi={true}
				onChange={fetchResendPostbackLookup}
				options={resendLookups.campaignes}
			/>

			<Field
				name="conversions"
				placeholder={intl('Конверсии')}
				component={SelectField}
				multi={true}
				onChange={fetchResendPostbackLookup}
				searchable={true}
				options={resendLookups.conversions}
			/>
		</div>
	</form>
);

const PostbackResendFilter = reduxForm({
	form: 'postbackResendFilter'
})(Form);

export default connect(
	state => ({
		data: selectors.getData(state),
		progressBar: selectors.getProgressBar(state),
		calendar: selectors.getCalendar(state),
		resendPostbacksLeft: selectors.getResendPostbacksLeft(state),
		dataTable: selectors.getLogTable(state),
		resendLookups: selectors.getResendLookups(state),
		resendPostbacksTotal: selectors.getResendPostbacksTotal(state),
		logTable: selectors.getLogTable(state),
		errors: selectors.getError(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(ResendMainForm);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/global-postback/resendPostback.js